var m = require('mithril');
var moment = require('moment-timezone');
import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import rrulePlugin from '@fullcalendar/rrule';

const component = {};

component.config = function config (parentCtrl) {
  return function (element, isInitialized, context) {
    if (!isInitialized) {
        context.calendar = parentCtrl.calendar = new Calendar(element, {
        plugins: [ interactionPlugin, timeGridPlugin, rrulePlugin ],
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        defaultView: 'timeGridWeek',
        timeZone: 'local', 
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'timeGridWeek,timeGridDay'
        },
        events: function (fetchInfo, successCallback, failureCallback) {
          successCallback(parentCtrl.value)
        },
        dateClick: function(info) {
          parentCtrl.addEvent.call(parentCtrl, context.calendar, info);
        },
        eventClick: function (info) {
          parentCtrl.editEvent.call(parentCtrl, context.calendar, info);
        }

      });
      context.calendar.render();
    }
  }
};

component.oninit = function () {
  
}

component.view = function (ctrl, parentCtrl) {
  return m('div.container.mb2.pb4', {oninit: component.config(parentCtrl)})
}